import React from 'react';
import { Business } from 'models/business';

export interface MenuListItem {
  name: string;
  icon?: React.FC;
  clickHandler?: () => void;
  hidden?: boolean;
  disabled?: boolean;
  navigation?: {
    href: string;
  };
  disabledForStatus?: string[];
  hiddenForStatus?: string[];
  shouldDisable?: (business?: Business) => boolean;
}

export const disabledForStatuses =
  (statuses: string[]) => (business?: Business) =>
    statuses.includes(business?.status ?? '');
